module.exports = __webpack_public_path__ + "static/media/m_faceshape_square.52acf169.png";